import React, { useState } from 'react';
import { Stack } from 'library/ui';
import { AvailableTeacher } from 'models';
import { useModalsContext } from 'ModalsContext';
import moment from 'moment-timezone';
import AvailableTeacherCard from './AvailableTeacherCard';
import EditOrCreateNewJobModal from './EditOrCreateNewJobModal';
import {
    teacherToSpotlightWorkerApiObject,
    timeslotToDaysOfWeekApiObject,
    timeslotToJobTimesApiObject,
} from './inviteUtils';

export default function AvailableTeachersList({ teachers }: { teachers: AvailableTeacher[] }) {
    const [inviteModalOpen, setInviteModalOpen] = useState(false);
    const [selectedWorker, setSelectedWorker] = useState<AvailableTeacher[]>([]);
    const [selectedTimeslot, setSelectedTimeslot] = useState<{ upper: string; lower: string; timezone: string }>();

    const { openJobForm } = useModalsContext();

    function openInviteModal(teacher: AvailableTeacher, lower: string, upper: string, timezone?: string) {
        setSelectedWorker([teacher]);
        setSelectedTimeslot({ lower, upper, timezone: timezone ?? 'America/New_York' });
        setInviteModalOpen(true);
    }

    function closeAndReset() {
        setInviteModalOpen(false);
        setSelectedWorker([]);
        setSelectedTimeslot(undefined);
    }

    function request() {
        if (!selectedTimeslot || !selectedWorker) {
            return;
        }
        const formattedWorker = teacherToSpotlightWorkerApiObject(selectedWorker[0]);

        setSelectedWorker([]);

        openJobForm('Available Teachers', {
            selectedSpotlightWorkers: [formattedWorker],
            allSpotlightWorkers: [formattedWorker],
            startDate: moment(selectedTimeslot?.lower),
            endDate: moment(selectedTimeslot?.upper),
            daysOfTheWeek: timeslotToDaysOfWeekApiObject(selectedTimeslot),
            jobTimes: timeslotToJobTimesApiObject(selectedTimeslot),
        });
    }

    return (
        <Stack gap="md">
            {teachers.map((teacher) => (
                <AvailableTeacherCard key={teacher.id} teacher={teacher} requestToBook={openInviteModal} />
            ))}
            <EditOrCreateNewJobModal
                open={inviteModalOpen}
                onClose={closeAndReset}
                selectedWorkers={selectedWorker}
                openJobForm={request}
            />
        </Stack>
    );
}
